@if (macroStatus && macroStatusMeta[macroStatus]) {
  <span class="clinical-onboarding-status-badge" [style.color]="macroStatusMeta[macroStatus].color" [style.borderColor]="macroStatusMeta[macroStatus].color">
    <mat-icon>{{ macroStatusMeta[macroStatus].icon }}</mat-icon>
    <span>{{ macroStatusMeta[macroStatus].i18nKey | translate }}</span>
  </span>
}
